import PulseLoader from "@hudson/ui/components/Loader/PulseLoader";
import FrameConfig from "@lib/classes/FrameConfig";
import logoutProfile from "@lib/services/logout_profile";
import Session from "@lib/session";
import useConfig from "@lib/use_config";
import useContent from "@lib/use_content";
import classNames from "classnames";
import { useState } from "react";
import regexifyString from "regexify-string";

function LogoutGroup({}): JSX.Element | null {
  const { data, loading } = useContent(["beGroupLogoutLabel", "groupName", "charterName"]);
  const { data: configData, loading: configLoading } = useConfig(["lockGroupProfile"]);
  const [loggingOut, setLoggingOut] = useState(false);

  if (!Session.getBooking().profiles.group && !Session.getBooking().profiles.charter) return null;

  const charterLoggedIn = Session.getBooking().profiles.charter;

  let logoutGroupLabel = regexifyString({
    pattern: /_CODE_/gi,
    decorator: (match: string, index: number) => (
      <span key={index} className="font-extrabold" style={{ color: "var(--primary-color)" }}>
        {charterLoggedIn ? data?.content.charterName : data?.content.groupName}
      </span>
    ),
    input: data?.content.beGroupLogoutLabel,
  });

  async function logoutGroup() {
    setLoggingOut(true);
    await logoutProfile(charterLoggedIn ? "CHARTER" : "GROUP");
    await Session.clearSession();
    window.location.href = `${process.env.basePath}/${window.siteId}/book`;
  }

  if (
    !charterLoggedIn &&
    (new FrameConfig().lockGroupProfile || configData?.config.lockGroupProfile)
  )
    return null;

  return loading || configLoading ? null : (
    <div className="flex items-center">
      <a
        href="#"
        className={classNames("hover:opacity-75", { "opacity-75": loggingOut })}
        onClick={logoutGroup}
      >
        {logoutGroupLabel}
      </a>
      {loggingOut && <PulseLoader size={1} className="pl-1" />}
    </div>
  );
}

export default LogoutGroup;
